<mat-dialog-content class="container">
    <div class="flex space-between baseline mb-10">
        <h4>{{ 'general.change_password' | translateWithKeys }}</h4>
        <button class="close-btn" mat-icon-button (click)="cancel()">
            <mat-icon class="close-icon" svgIcon="close_black"></mat-icon>
        </button>
    </div>

    <div class="form-container">
        <form class="flex column" (keydown.enter)="handleEnterKey($event)" autocomplete="off" #form>
            <mat-form-field appearance="outline" class="pb-16">
                <input matInput name="currentPassword" [(ngModel)]="updatePasswordDto.currentPassword"
                    [type]="passwordVisibility.currentPassword ? 'text' : 'password'"
                    placeholder="{{'login.current_password' | translateWithKeys}}" [formControl]="currentPasswordFormControl"
                    (blur)="currentPasswordFormControl.markAsTouched()" required>
                <mat-icon matSuffix [svgIcon]="passwordVisibility.currentPassword ? 'visibility' : 'visibility_off'"
                    (click)="togglePasswordVisibility('currentPassword')"></mat-icon>
                <mat-error *ngIf="currentPasswordFormControl.invalid">
                    <mat-icon svgIcon="info_error" class="icon"></mat-icon>
                    <span class="pl-8">{{errorMessages.currentPassword() | translateWithKeys}}</span>
                </mat-error>
            </mat-form-field>

            <div class="flex column mb-10">
                <p class="title">{{ 'login.new_password' | translateWithKeys }}</p>
                <p class="body3">{{ 'login.password_minimum_message' | translateWithKeys }}</p>
            </div>

            <mat-form-field appearance="outline" class="pb-16">
                <input matInput name="Password" [(ngModel)]="updatePasswordDto.newPassword"
                    [type]="passwordVisibility.newPassword ? 'text' : 'password'"
                    placeholder="{{'login.new_password' | translateWithKeys}}" [formControl]="newPasswordFormControl"
                    (blur)="newPasswordFormControl.markAsTouched()" required>
                <mat-icon matSuffix [svgIcon]="passwordVisibility.newPassword ? 'visibility' : 'visibility_off'"
                    (click)="togglePasswordVisibility('newPassword')"></mat-icon>
                <mat-error *ngIf="newPasswordFormControl.invalid">
                    <mat-icon svgIcon="info_error" class="icon"></mat-icon>
                    <span class="pl-8">{{errorMessages.newPassword() | translateWithKeys:{ params: errorMessages.newPassword() === 'general.password_min_length_error' ? { amount: PASSWORD_MIN_LENGTH } : {} } }}</span>
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="pb-16">
                <input matInput name="repeatPassword" [(ngModel)]="repeatPassword"
                    [type]="passwordVisibility.repeatPassword ? 'text' : 'password'"
                    placeholder="{{'login.confirm_new_password' | translateWithKeys}}"
                    [formControl]="repeatPasswordFormControl" (blur)="repeatPasswordFormControl.markAsTouched()" required>
                <mat-icon matSuffix [ngClass]="{'check-icon': updatePasswordDto.newPassword === repeatPassword && updatePasswordDto.newPassword && repeatPassword}" [svgIcon]="
                (updatePasswordDto.newPassword === repeatPassword && updatePasswordDto.newPassword && repeatPassword)
                ? 'check_rounded'
                : (passwordVisibility.repeatPassword ? 'visibility' : 'visibility_off')"
                (click)="togglePasswordVisibility('repeatPassword')"></mat-icon>
                <mat-error *ngIf="repeatPasswordFormControl.invalid">
                    <mat-icon svgIcon="info_error" class="icon"></mat-icon>
                    <span class="pl-8">{{errorMessages.repeatPassword() | translateWithKeys:{ params: errorMessages.repeatPassword() === 'general.password_min_length_error' ? { amount: PASSWORD_MIN_LENGTH } : {} }  }}</span>
                </mat-error>
                <mat-hint *ngIf="userError" class="errorClass colorError matHint w-100">
                    <mat-icon svgIcon="info_error" class="icon"></mat-icon>
                    <span class="pl-8">{{errorEmptyMessage() | translateWithKeys}}</span>
                </mat-hint>
            </mat-form-field>

            <div *ngIf="userValidationErrors" class="flex row center options pb-32">
                <mat-hint class="errorExpired bg-warn-lighter text-warn">
                    <mat-icon svgIcon="info_error" class="icon"></mat-icon>
                    <span class="pl-8">{{errorEmptyMessage() | translateWithKeys}}</span>
                </mat-hint>
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="flex space-between">
    <button mat-stroked-button class="button" (click)="cancel()">{{ 'general.cancel' | translateWithKeys }}</button>
    <button mat-stroked-button class="button save-button" (click)="save()">{{ 'general.save' | translateWithKeys }}</button>
</mat-dialog-actions>
